import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClaimRewardComponent } from './claim-reward.component';
import { XIconModule } from '@app/dynamic-ui/x-icon/x-icon.module';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ClaimRewardComponent
  ],
  imports: [
    CommonModule,
    XIconModule,
    RouterModule,
    ReactiveFormsModule
  ]
})
export class ClaimRewardModule { }
